/**
 * Generic placeholder rendered for routes that don't have a real page yet.
 *
 * Task 002 (router setup) wires up navigation for all ~23 legacy AngularJS
 * states, but the actual screens are ported module-by-module in later tasks
 * (014+). Rather than hand-writing 23 near-identical placeholder components,
 * every route points at this one component and passes a `name` (and
 * optionally the legacy UI-Router state it replaces) so navigation/QA can be
 * validated end-to-end before the real modules land.
 *
 * `prop-types` isn't a project dependency (JS-only scaffold, no runtime
 * prop validation elsewhere yet), so the `react/prop-types` lint rule is
 * disabled here rather than pulling in a new dependency for a placeholder
 * that later tasks will delete route-by-route.
 */
// eslint-disable-next-line react/prop-types
function RoutePlaceholder({ name, legacyState, legacyUrl }) {
  return (
    <div className="route-placeholder">
      <h2>{name}</h2>
      <p>Placeholder route — real page will be implemented in a later task.</p>
      {legacyState && (
        <p>
          <small>
            AngularJS state: <code>{legacyState}</code>
            {legacyUrl ? <> (<code>{legacyUrl}</code>)</> : null}
          </small>
        </p>
      )}
    </div>
  )
}

export default RoutePlaceholder
